import { validateEmail } from "../Login/Validation";
type data = {
  name: string;
  password: string;
  role: any;
  email: string;
  status: string;
  outlet: string;
};
export const validateAddMerchant = (data: data, setError: (a: any) => void) => {
  let isError = false;
  if (data.name === "") {
    setError((prevState: any) => ({
      ...prevState,
      name: "Please enter Merchant Name",
    }));
    isError = true;
  }
  if (data.role.includes(3) && data.outlet === "") {
    setError((prevState: any) => ({
      ...prevState,
      outlet: "Please select outlet",
    }));
    isError = true;
  }
  if (data.role.includes(5) && data.outlet === "") {
    setError((prevState: any) => ({
      ...prevState,
      outlet: "Please select outlet",
    }));
    isError = true;
  }
  if (data.role.includes(8) && data.outlet === "") {
    setError((prevState: any) => ({
      ...prevState,
      outlet: "Please select outlet",
    }));
    isError = true;
  }
  if (data.password === "") {
    setError((prevState: any) => ({
      ...prevState,
      password: "Please enter password",
    }));
    isError = true;
  }
  if (data.role === "") {
    setError((prevState: any) => ({ ...prevState, role: "Please enter role" }));
    isError = true;
  }
  if (data.email === "") {
    setError((prevState: any) => ({
      ...prevState,
      email: "Please enter email",
    }));
    isError = true;
  } else {
    if (!validateEmail(data.email)) {
      setError((prevState: any) => ({
        ...prevState,
        email: "Please enter valid email",
      }));
      isError = true;
    }
  }
  if (data.status === "") {
    setError((prevState: any) => ({
      ...prevState,
      status: "Please enter status",
    }));
    isError = true;
  }

  return isError;
};
